import * as React from 'react';

import LinkAccountsWithFastLink from '../payment/LinkAccountsWithFastLink';
import Button from '../styleguide/Button';
import SuccessMessage from '../styleguide/SuccessMessage';
import ErrorMessage from '../styleguide/ErrorMessage';
import aeropayConnectBank from '../../assets/aeropay_connect_bank_blkblu.png';
import PropTypes from 'prop-types';

import styles from './LinkAccountsCallout.module.css';

const LinkAccountsCallout = ({onGreen}) => {
  
  const [linkAccount, setLinkAccount] = React.useState();
  const [responseMessage, setResponseMessage] = React.useState();

  const onSuccess = (event) => {
    setResponseMessage(<SuccessMessage text={event.message} />);
    setLinkAccount(false);
    window.fastlink.close();
  }

  const onFailure = (event) => {
    setResponseMessage(<ErrorMessage text={event.message} />);
    setLinkAccount(false);
    window.fastlink.close();
  }

  const buttonClick = () => {
    setLinkAccount(true); 
    setResponseMessage('');
  }

  return (
    <div className={styles.calloutWrap}>
      { linkAccount
          ? <LinkAccountsWithFastLink 
             onSuccess={onSuccess}
             onFailure={onFailure} />
          : onGreen
            ? <img className={styles.apButton} alt="Connect Your Bank with AeroPay" src={aeropayConnectBank} onClick={buttonClick} />
            : <Button text="Link Bank Account" handleClick={buttonClick} />  
      }
      { responseMessage &&
        <div>{responseMessage}</div>
      }
    </div>
  )
}

LinkAccountsCallout.propTypes = {
  onGreen: PropTypes.bool
}

export default LinkAccountsCallout;